import React, { useRef, useEffect } from 'react'
import { ScanSettings, configure, BarcodePicker } from 'scandit-sdk'

interface ScannerProps {
	onDetect: (barcode: string) => void
	onError: (err: string) => void
}

const configuration = configure(process.env.REACT_APP_SCANDIT_LICENSE_KEY as string, {
	engineLocation: 'https://cdn.jsdelivr.net/npm/scandit-sdk@5.x/build/',
}).catch((error) => {
	console.log(error)
})

const options = {
	playSoundOnScan: true,
	vibrateOnScan: true,
	scanSettings: new ScanSettings({
		enabledSymbologies: ['ean8', 'ean13'],
		codeDuplicateFilter: 1000
	} as any)
}

const Scanner: React.FC<ScannerProps> = props => {
	const ref = useRef(null)
	const barcodePickerRef = useRef<any>(null)

	useEffect(() => {
		if (ref.current !== null) {
			configuration.then(() => {
				BarcodePicker.create(ref.current!, options).then(barcodePicker => {
					barcodePickerRef.current = barcodePicker
					barcodePicker.on('scan', result => {
						const barcode = result.barcodes.slice(-1)[0]

						if (barcode) {
							props.onDetect(barcode.data)
						}
					})
					barcodePicker.on('scanError', console.log)
				})
			})
		}

		return () => {
			if (barcodePickerRef.current !== null) {
				barcodePickerRef.current.destroy()
			}
		}
	}, [])

	return (
		<div ref={ref} />
	)
}

export default Scanner
